import React from 'react';
import { connect } from 'react-redux';
import { TopNavigationBar } from '@bit/knotchinc.web-react-components.page';
import NotificationSync from '@bit/knotchinc.web-react-components.notification-sync';
import BlueprintSearch from 'components/TopBar/BlueprintSearch.jsx';
import BreadcrumbsContainer from 'components/Global/Breadcrumbs/BreadcrumbsContainer.jsx';
import { fetchNotifications, hideAlert, SET_NOTIFICATION_LIST_FILTER, clearAllNotifications } from 'actions/notifications.js';
import Notification from 'components/Global/Notification/Notification.jsx';

// MAIN PAGE
export class TopBar extends React.Component {
  render() {
    const { pathname, notificationList, getNotifications, markPageAsSeen, clearAllAlerts } = this.props;
    return (
      <TopNavigationBar>
        <BreadcrumbsContainer />
        <NotificationSync
          fetch={(clear, count) => getNotifications(clear, count)}
          listStore={notificationList}
          actionType={SET_NOTIFICATION_LIST_FILTER}
          loadOnScroll
          markPageAsSeen={(alertId) => markPageAsSeen(alertId)}
          clearAllAlerts={clearAllAlerts}
        >
          <Notification />
        </NotificationSync>
        <BlueprintSearch pathname={pathname} />
      </TopNavigationBar>
    );
  }
}

const mapStateToProps = ({ Notifications: { notificationList } }) => ({
  notificationList,
});

const mapDispatchToProps = dispatch => ({
  getNotifications: (clear, count) => dispatch(fetchNotifications(clear, count)),
  markPageAsSeen: (alertId) => dispatch(hideAlert({ alertId })),
  clearAllAlerts: () => dispatch(clearAllNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
